import {Text, Label, Stack, StackItem, TextField, IconButton, ComboBox, IComboBoxOption, IComboBox } from '@fluentui/react';
import * as React from 'react';
import { render } from 'react-dom';
import { IAttendee } from '../../../Models/Attendees/IAttendee';
import { EventPriceTypeEnum } from '../../../Models/Event/EventPriceTypeEnum';
import { IEvent } from '../../../Models/Event/IEvent';
import { IOrder } from '../../../Models/Order/IOrder';
import { IOrderItem } from '../../../Models/Order/IOrderItem';
import { OrderStateEnum, orderStateEnumToString } from '../../../Models/Order/OrderStateEnum';
import { strToDate } from '../../../Tools/DateTime';

interface IOrderDetailViewProps {
    item?: IOrder;
    isLoading: boolean;
    isAdmin: boolean;
    changeState: (orderId: number, state: OrderStateEnum) => void;
}
 



export const OrderDetailView: React.FunctionComponent<IOrderDetailViewProps> = (props) => {

    const renderAttendee = (a: IAttendee, priceType: EventPriceTypeEnum,
    price: number,
    firstSemesterPrice: number,
    secondSemesterPrice: number) =>
    {
        return <Stack horizontal horizontalAlign="start"  >
            <Stack.Item grow align="start" >
                <span><b>{a.firstName + " " + a.lastName}</b></span>
                <span> datum narození: { strToDate(a.dateOfBirth as string).toLocaleDateString('cs-CZ')}</span>
            </Stack.Item>
            <Stack.Item align="end">
                {priceType === EventPriceTypeEnum.ByEvent?
                    <span> {price},- /akce</span> : null}

                {priceType === EventPriceTypeEnum.BySemester ?
                    firstSemesterPrice === secondSemesterPrice?
                        <span> {firstSemesterPrice},- /pololetí</span> : 
                        <span> {firstSemesterPrice},- / 1 pololetí<br />
                               {secondSemesterPrice},- / 2 pololetí
                        </span> :null                         
                        }

            </Stack.Item>
        </Stack>
    }
    const renderEvent = (e: IOrderItem) => {
        return (<Stack tokens={{ childrenGap:0 }}>
            <Label>{e.name}</Label>
            <Stack horizontal tokens={{ childrenGap: 15 }}>
            <Stack horizontal verticalAlign="center" tokens={{ childrenGap:5 }}>
                    <Text>Přihlášky </Text>
                    <Label title="Kapacita">{e.seets}</Label> 
                <Text>/</Text>
                    <Label title="Přihlášeno">{e.seetsTaken}</Label>
            </Stack>
            <Stack horizontal verticalAlign="center" tokens={{ childrenGap: 5 }}>
                    <Text>Náhradníci</Text>
                    <Label title="Kapacita">{e.substitutes}</Label>
                <Text>/</Text>
                    <Label title="Přihlášeno">{e.substitutesTaken}</Label>
                </Stack>
            </Stack>
            
            <Label styles={{ root: { fontStyle: "italic", fontWeight:400 } }}>Přihlášení žáci:</Label>
            {e.attendees.map(item => renderAttendee(item, e.priceType, e.price, e.firstSemesterPrice, e.secondSemesterPrice))}
        </Stack>)
    }

    const onChange = (event: React.FormEvent<IComboBox>, option?: IComboBoxOption, index?: number, value?: string) => {

        if (option && props.changeState && props.item) {
            props.changeState(props.item?.id, option.key as OrderStateEnum);
        }
    };


    const stateOptions: IComboBoxOption[] = [
        { key: OrderStateEnum.New, text: "Nová", disabled: true },
        { key: OrderStateEnum.Approved, text: "Ověřeno (bude odesláno potvrzení, vytvořena faktura a odeslán email => Dokončeno )" },
        { key: OrderStateEnum.ApprovedManualSend, text: "Ověřeno ruční zpracování (bude vytvořena rezervace míst na akci)" },
        { key: OrderStateEnum.Processed, text: "Místa rezervována (bude vystavena faktura => Faktura vystavena)", disabled: props.item?.orderState === 0 },
        { key: OrderStateEnum.ProcessedManual, text: "Místa rezervována", disabled: props.item?.orderState === 0 },
        { key: OrderStateEnum.Invoiced, text: "Faktura vystavena (bude odeslán email s fakturou a přihláškou => Dokončeno)", disabled: props.item?.orderState === 0 },
        { key: OrderStateEnum.Closed, text: "Dokončeno", disabled: props.item?.orderState === 0 },
        { key: OrderStateEnum.Canceled, text: "Zrušena", },]


    return (<>
        <Stack tokens={{ childrenGap: 15 }} styles={{ root: { paddingTop: 40 } }}>
            {props.item ?
                <Stack tokens={{ childrenGap: 15 }} >
                    <Label>Fakturační adresa</Label>
                    {props.item.company ?
                        <Stack tokens={{ childrenGap: 15 }}>
                            <TextField id="company" key="company" label="Firma" disabled={props.isLoading} value={props.item.company} />
                            <Stack horizontal tokens={{ childrenGap: 15 }}>
                                <StackItem grow>
                                    <TextField id="ic" key="ic" label="IČ" disabled={props.isLoading} value={props.item.ic} />
                                </StackItem>
                                <StackItem grow>
                                    <TextField id="dic" key="dic" label="DIČ" disabled={props.isLoading} value={props.item.dic} />
                                </StackItem>
                            </Stack>
                        </Stack> : null}
                    <Stack horizontal tokens={{ childrenGap: 15 }}>
                        <StackItem grow>
                            <TextField id="firstName" key="firstName" label="Jméno" disabled={props.isLoading} value={props.item.firstName} />
                        </StackItem>
                        <StackItem grow>
                            <TextField id="lastName" key="lastName" label="Příjmení" disabled={props.isLoading} value={props.item.lastName} />
                        </StackItem>
                    </Stack>
                    <TextField id="street" key="street" label="Ulice" disabled={props.isLoading} value={props.item.billingAddress.street} />
                    <Stack horizontal tokens={{ childrenGap: 15 }}>
                        <StackItem grow>
                            <TextField id="city" key="city" label="Město" disabled={props.isLoading} value={props.item.billingAddress.city} />
                        </StackItem>
                        <StackItem grow>
                            <TextField id="postalCode" key="postalCode" label="PSČ" disabled={props.isLoading} value={props.item.billingAddress.postalCode} />
                        </StackItem>
                    </Stack>
                    {props.isAdmin ?
                        <ComboBox disabled={props.isLoading || !props.isAdmin} onChange={onChange} label="Stav objednávky" options={stateOptions} selectedKey={props.item.orderState} />
                        :
                        <Stack>
                            <Label>Stav objednávky</Label>
                            <Text>{orderStateEnumToString(props.item.orderState)}</Text>
                        </Stack>
                    }
                    <Label>Objednané akce:</Label>
                    {props.item.items.map(item => renderEvent(item))}
                </Stack>

        : null}
        </Stack>
        </>)
}

